import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, catchError, Observable, of, switchMap, tap, Subject, takeUntil, distinctUntilChanged } from 'rxjs';
import { AvatarService } from '@core/services/avatar/avatar.service';
import { PLACEHOLDER_IMAGE } from '@core/utils/utils';

@Component({
  selector: 'hoc-profile-image',
  templateUrl: './hoc-profile-image.component.html',
  styleUrls: ['./hoc-profile-image.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HocProfileImageComponent implements OnInit, OnDestroy {
  private identifier$ = new BehaviorSubject<string | null | undefined>(null);

  @Input()
  set value(identifier: string | null | undefined) {
    this.identifier$.next(identifier);
  }
  public avatarImage$!: Observable<string>;
  private valueChanges$ = new BehaviorSubject<string | null | undefined>(null);
  private destroy$ = new Subject<void>();

  constructor(private avatarService: AvatarService) {}
  ngOnInit(): void {
    distinctUntilChanged(),
    this.avatarImage$ = this.identifier$.pipe(
      tap(identifier => {
        console.log('[HocProfileImageComponent] Identifier received:', identifier);
      }),
      switchMap(identifier => {
        if (!identifier) {
          console.log('[HocProfileImageComponent] No identifier provided, using placeholder.');
          return of(PLACEHOLDER_IMAGE);
        }
        return this.avatarService.getAvatarImage(identifier!).pipe(
          catchError((error: unknown) => {
            console.error(`[HocProfileImageComponent] Failed to get avatar for identifier "${identifier}". `, error );
            return of(PLACEHOLDER_IMAGE);
          })
        );
      }),
      takeUntil(this.destroy$)
    );
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
